// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (min-width: 992px) {\n#simulation-details .is-horizontal .field-label {\n    -webkit-box-flex: 3;\n        -ms-flex-positive: 3;\n            flex-grow: 3;\n}\n}\n", ""]);
// Exports
module.exports = exports;
